export default {"src":"/_next/static/media/error.c080721d.svg","height":153,"width":250};